export default __webpack_public_path__ + "static/media/Gear-0.2s-100px.67646aa3.svg";